/* eslint-disable import/no-unresolved */
import { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { useMutation, useReactiveVar } from '@apollo/client';
import {
    Button, Modal, Radio, RadioGroup, TextArea,
} from 'appkit-react';

import { CREATE_CLASSIFY_AUDIT_LOGS_FOR_FFIEC009 } from 'Apollo/Mutations/Rules/FFIEC009';
import { tenantIdVar } from 'Apollo/config';
import closeIcons from 'assets/images/close-24px.svg';
import issueConfirmed from 'assets/images/issue-confirmed-icon.svg';
import noIssue from 'assets/images/no-issue-md.svg';
import reviewRequired from 'assets/images/review-required.svg';

const FFIEC009ClassifyResult = ({
    setShowClassifyResult, refetch, refetchTestData,
}) => {
    const location = useLocation();
    const [batchId, setBatchId] = useState(location.state.batchId);
    const [ruleId, setRuleId] = useState(location.state.ruleId);

    const [comment, setComment] = useState('');
    const [radio, setRadio] = useState('MARK_AS_REVIEW_REQUIRED');
    const [showLoader, setShowLoader] = useState(false);
    const tenantId = useReactiveVar(tenantIdVar);

    /* Apollo mutation to update the comment */
    const [updateComment] = useMutation(
        CREATE_CLASSIFY_AUDIT_LOGS_FOR_FFIEC009,
        {
            variables: {
                input: {
                    comment,
                    batchId: Number(batchId),
                    eventName: radio,
                    ruleId: Number(ruleId),
                    tenantId: Number(tenantId),
                },
            },
        },
    );

    /* Side effect when location state updates */
    useEffect(() => {
        setBatchId(location.state.batchId);
        setRuleId(location.state.ruleId);
    }, [location]);

    /* Calls updateComment(), refetches the failed test and audit logs data  */
    const onClickClassify = async () => {
        setShowLoader(true);
        await updateComment();
        setComment('');
        setShowLoader(false);
        refetch();
        refetchTestData();
        setShowClassifyResult(false);
    };

    return (
        <Modal
            className="baseline-modal-showcase true-comply-classify__result__modal"
            visible
        >
            <Container className="true-comply-classify__result__modal-container">
                <Row className="true-comply-classify__result__modal-head-section">
                    <Col sm={1} md={1}>
                        <img
                            src={closeIcons}
                            alt="modal close"
                            onClick={() => { setShowClassifyResult(false); }}
                            aria-hidden="true"
                            data-testid="set-page-name"
                        />
                    </Col>
                    <Col sm={10} md={10}>
                        <div className="true-comply-classify__result__modal-title">
                            ClassifyResult
                        </div>
                    </Col>
                    <Col sm={1} md={1}>
                        <Button
                            size="xl"
                            disabled={!comment}
                            onClick={() => onClickClassify()}
                            isLoading={showLoader}
                            data-testid="classify-btn"
                        >
                            Classify
                        </Button>
                    </Col>
                </Row>
                <div className="border-bottom" />
                <div className="true-comply-classify__result__modal-body-section">
                    <Row>
                        <Col
                            md={{ span: 7, offset: 2 }}
                            className="true-comply-classify__result__modal-body-section-title"
                        >
                            Classify Exceptions
                        </Col>
                    </Row>
                    <Row>
                        <Col md={{ span: 5, offset: 2 }}>
                            <p>
                                Review Required – Four eye check. Assign to another
                                resource for review .
                            </p>
                            <p>
                                {' '}
                                Issue Confirmed – Issue Confirmed, assign for remediation.
                            </p>
                            <p> No Issue – Not a real issue. False positive. </p>
                        </Col>
                        <Col md={{ span: 3 }}>
                            <div className="true-comply-classify__result__modal-body-section__img-continer">
                                <img
                                    src={reviewRequired}
                                    alt="Review Required"
                                    aria-hidden="true"
                                />
                                <img
                                    src={issueConfirmed}
                                    alt="Issue Confirmed"
                                    aria-hidden="true"
                                />
                                <img src={noIssue} alt="No Issue" aria-hidden="true" />
                            </div>
                        </Col>
                    </Row>
                    <Row className="true-comply-classify__result__modal-body-section__radio-group">
                        <Col
                            md={{ span: 4, offset: 2 }}
                            className="true-comply-classify__result__modal-body-section__radio-group-title"
                        >
                            Schedule Name
                        </Col>
                        <Col md={{ span: 4 }}>
                            <RadioGroup
                                name="radioname"
                                value={radio}
                                onChange={(event, value) => setRadio(value)}
                                data-testid="set-radio-name"
                            >
                                <Radio value="MARK_AS_REVIEW_REQUIRED">Review required</Radio>
                                <Radio value="MARK_AS_ISSUE">Issue confirmed</Radio>
                                <Radio value="MARK_AS_NO_ISSUE">No issue</Radio>
                            </RadioGroup>
                        </Col>
                    </Row>
                    <div className="secondary-input-container  a-apply-theme-background-gray-level-2">
                        <Row className="true-comply-classify__result__modal-body-section__comment-section">
                            <Col md={{ span: 4, offset: 2 }}>
                                <p>
                                    Leave a comment
                                    <span className="required-txt"> (required)</span>
                                </p>
                            </Col>
                            <Col md={{ span: 4 }}>
                                <TextArea
                                    placeholder="Type here..."
                                    className="fix-textarea"
                                    value={comment}
                                    onChange={value => setComment(value)}
                                    data-testid="comment-change"
                                />
                                {!comment ? (
                                    <p className="warn-txt">Please write comment.</p>
                                ) : (
                                    <p className="warn-txt" />
                                )}
                            </Col>
                        </Row>
                    </div>
                </div>
            </Container>
        </Modal>
    );
};

export default FFIEC009ClassifyResult;
